import FixturePhotos from "./FixturePhotos";
export default FixturePhotos;
